import { render, staticRenderFns } from "./Floatdiv.vue?vue&type=template&id=0f79bb1e&scoped=true"
import script from "./Floatdiv.vue?vue&type=script&lang=js"
export * from "./Floatdiv.vue?vue&type=script&lang=js"
import style0 from "./Floatdiv.vue?vue&type=style&index=0&id=0f79bb1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f79bb1e",
  null
  
)

export default component.exports